import { logger } from '@/config/logger'
import { fetchAuthSession } from 'aws-amplify/auth'
import { useCallback, useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { Link } from 'react-router-dom'
import { API, fetchCompanyConsumption, fetchUser } from '../api'
import Button from '../components/Button'
import FullScreenLayout from '../components/FullScreenLayout'

export const CheckoutResult = () => {
  const [stripeStatus, setStripeStatus] = useState(null)
  const [isSubUpdated, setIsSubUpdated] = useState(false)
  const [customerEmail, setCustomerEmail] = useState('')

  // This function fetches the initial session info
  const fetchSession = useCallback(async () => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const sessionId = urlParams.get('session_id')

    try {
      const session = await fetchAuthSession()
      const response = await API(session).get(
        `/stripe/session-status?sessionId=${sessionId}`
      )

      setIsSubUpdated(response.data.updated_subscription)
      setStripeStatus(response.data.stripe_status)
      setCustomerEmail(response.data.customer_email)
    } catch (error) {
      logger.error('Error fetching session status:', error)
      // Handle error appropriately, possibly setting an error state
    }
  }, [])

  // Poll the subscription status every second if payment is complete but subscription is not yet updated
  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null

    // Only start polling when stripeStatus is "complete" and subscription not updated
    if (stripeStatus !== 'complete' || !isSubUpdated) {
      intervalId = setInterval(async () => {
        // Re-fetch the session status
        try {
          fetchUser()
          fetchCompanyConsumption()
          await fetchSession()

          // Stop polling if subscription is updated
          if (stripeStatus === 'complete' && isSubUpdated) {
            if (intervalId) clearInterval(intervalId)
          }
        } catch (error) {
          logger.error('Error polling subscription status:', error)
        }
      }, 3000)
    }

    return () => {
      if (intervalId) clearInterval(intervalId)
    }
  }, [stripeStatus, isSubUpdated])

  return (
    <>
      {stripeStatus === 'complete' ? (
        <FullScreenLayout title="" subtitle="">
          <div className="text-center mt-8 mb-8">
            <h3 style={{ fontWeight: 'bold', marginBottom: '2rem' }}>
              Purchase confirmation
            </h3>
            <p className="mb-4">
              You will receive an email at <strong>{customerEmail}</strong>{' '}
              confirming your payment.
            </p>
            <p className="mb-8">You can start right away!</p>
          </div>
          <div className="w-full mt-8">
            <div className="w-60 mx-auto">
              <Button
                as={Link}
                label="Process my files"
                to="/"
                className="w-20 mx-auto"
              />
            </div>
          </div>
        </FullScreenLayout>
      ) : (
        <FullScreenLayout
          title={<Skeleton width={200} />}
          subtitle={<Skeleton width={300} />}
        >
          <div className="w-60 mx-auto">
            <Skeleton />
          </div>
        </FullScreenLayout>
      )}
    </>
  )
}
